import styled, { css } from 'styled-components';

export const Wrapper = styled.nav`
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  gap: 8px;
`;

export const Dot = styled.button<{ current?: boolean }>`
  width: 8px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: var(--border-radius-round);
  background: var(--white);
  ${(props) =>
    props.current &&
    css`
      background: var(--primary);
    `}

  &::-moz-focus-inner {
    border: 0;
  }
`;
